var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"obj-center"},[_c('div',{staticClass:"d-flex justify-center"},[_c('img',{attrs:{"src":_vm.readMore}})])])}
var staticRenderFns = []

export { render, staticRenderFns }